export const SUBMENU_EDGE_GAP = 8;

/** The Actions menu is padded and nested menus are not, so the gap is measured from the outer edges. */
export const SUBMENU_VISUAL_GAP = 8;

export function flyoutMargin(anchorRight: number, surfaceRight: number, visualGap = SUBMENU_VISUAL_GAP) {
  const inset = Math.max(0, surfaceRight - anchorRight);
  return visualGap + inset;
}

export type SubmenuPlacement = {
  offsetTop: number;
  maxHeight?: number;
};

export function placeSubmenuAboveFooter(
  anchorTop: number,
  menuHeight: number,
  limitBottom: number,
  edgeGap = SUBMENU_EDGE_GAP,
): SubmenuPlacement {
  const maxBottom = limitBottom - edgeGap;
  const minTop = edgeGap;
  const available = Math.max(0, maxBottom - minTop);

  if (menuHeight > available) {
    return { offsetTop: minTop - anchorTop, maxHeight: available };
  }

  let top = anchorTop;
  if (top + menuHeight > maxBottom) {
    top = maxBottom - menuHeight;
  }
  if (top < minTop) {
    top = minTop;
  }

  return { offsetTop: top - anchorTop };
}

export function hoverBridgeBox(offsetTop: number, visibleHeight: number, anchorHeight: number) {
  const top = Math.min(0, offsetTop);
  const bottom = Math.max(anchorHeight, offsetTop + visibleHeight);
  return { top, height: bottom - top };
}

/** The gap outside the parent surface. Stays off the row and off a height-capped scrollbar. */
export function hoverBridgeHorizontal(anchorRight: number, surfaceRight: number, marginLeft: number) {
  const panelLeft = anchorRight + marginLeft;
  const left = Math.max(anchorRight, Math.min(surfaceRight, panelLeft));
  return { left, width: Math.max(0, panelLeft - left) };
}
